var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "dice",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 9",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "dice__d12",
    d: "M 4.5 0.75 L 6.75 1.5 L 8 3.5 L 8 5.75 L 6.75 7.5 L 4.5 8.25 L 2.25 7.5 L 1 5.75 L 1 3.5 L 2.25 1.5 L 4.5 0.75 L 6.75 1.5 M 4.5 2 L 6.75 3.75 L 6 6.5 L 3 6.5 L 2.25 3.75 L 4.5 2 M 4.5 2 L 4.5 0.75 M 6.75 3.75 L 8 3.5 M 6 6.5 L 6.75 7.5 M 3 6.5 L 2.25 7.5 M 2.25 3.75 L 1 3.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD12);
export default __webpack_public_path__ + "static/media/d12.c85cb70833d67035a846cc1efe7fe4a2.svg";
export { ForwardRef as ReactComponent };